import { Avatar, Badge, Button, Divider, List, Modal, Space, Tag, Tooltip, Typography } from "antd"
import dayjs from "dayjs"
import { useEffect, useState } from "react"
import { stripHtml } from "../../helpers/stripHtml"
import { tabFactory } from "../../helpers/tabsFactory"
import { generateKey } from "../../hooks/generateKey"
import { useUpdateTrainingMutation } from "../../network/useTraining"
import { TagFactory } from "../TagFactory"

export const BookingCard = ({ item, person, setRefetch, isAdmin }) => {
  const [acceptLoading, setacceptLoading] = useState(false)
  const [rejectLoading, setrejectLoading] = useState(false)
  const updateMutation = useUpdateTrainingMutation(item?.docId)
  const trainingUid = tabFactory("trainingRequestUid").get()

  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (item?.status === "pending" && item?.docId === trainingUid) setVisible(true)
  }, [item, trainingUid])

  const handleBooking = async (status) => {
    status === "requested" ? setacceptLoading(true) : setrejectLoading(true)
    try {
      updateMutation?.mutateAsync(
        {
          data: {
            status,
          },
        },
        { onSettled: () => (setRefetch ? setRefetch(true) : null) }
      )
      setacceptLoading(false)
      setrejectLoading(false)
      setVisible(false)
    } catch (error) {
      setacceptLoading(false)
      setrejectLoading(false)
      setVisible(false)
    }
  }
  return (
    <>
      <Modal
        onCancel={() => {
          setVisible(false)
          tabFactory("trainingRequestUid").onChange("")
        }}
        visible={visible}
        footer={null}
      >
        <List.Item
          style={{
            borderRadius: "0.625rem",
            marginBottom: "1rem",
          }}
          actions={[
            <Space key="activityActions">
              <Tag color="green">Training</Tag>
            </Space>,
          ]}
        >
          <List.Item.Meta
            avatar={<Avatar src={item?.training?.imageUrl} />}
            title={
              <Space>
                {item?.training?.title}
                <TagFactory status={item?.status}>{item?.status?.toSentenceCase()}</TagFactory>
              </Space>
            }
            description={
              <Space direction="vertical">
                <Divider />
                <Typography.Title level={5}>Members</Typography.Title>
                <Avatar.Group
                  maxCount={2}
                  maxStyle={{
                    color: "#f56a00",
                    backgroundColor: "#fde3cf",
                  }}
                >
                  {item.members.map((member) => (
                    <Tooltip key={generateKey(member.uid)} title={member.name}>
                      <Avatar src={member.imageUrl} />
                    </Tooltip>
                  ))}
                </Avatar.Group>
                <Divider />
                <Typography.Paragraph
                  ellipsis={{
                    rows: 2,
                    expandable: true,
                    symbol: "more",
                  }}
                >
                  {stripHtml(item?.training?.descriptionAsHTML)}
                </Typography.Paragraph>

                {item?.status === "pending" && isAdmin && (
                  <Space>
                    <Button
                      onClick={() => handleBooking("rejected")}
                      type="danger"
                      size="small"
                      disabled={acceptLoading}
                      loading={rejectLoading}
                    >
                      Reject
                    </Button>
                    <Button
                      loading={acceptLoading}
                      disabled={rejectLoading}
                      onClick={() => handleBooking("requested")}
                      type="primary"
                      size="small"
                    >
                      Approve
                    </Button>
                  </Space>
                )}
                <Badge
                  color="purple"
                  text={
                    <span className="badge--meta">
                      Date Range: {dayjs(item?.date[0]).format("DD/MM/YYYY")} -{" "}
                      {dayjs(item?.date[1]).format("DD/MM/YYYY")}
                    </span>
                  }
                />
              </Space>
            }
          />
        </List.Item>
      </Modal>
      <List.Item
        style={{
          border: item?.assignedToUid === person?.uid ? "1px solid rgba(11, 175, 224, 0.2)" : "",
          borderRadius: "0.625rem",
          marginBottom: "1rem",
        }}
        actions={[
          <Space className="hide--aboveMedium" key="activityActions">
            <Tag color="green">Training</Tag>
            <Avatar.Group
              maxCount={2}
              maxStyle={{
                color: "#f56a00",
                backgroundColor: "#fde3cf",
              }}
            >
              {item.members.map((member) => (
                <Tooltip key={generateKey(member.uid)} title={member.name}>
                  <Avatar src={member.imageUrl} />
                </Tooltip>
              ))}
            </Avatar.Group>
          </Space>,
        ]}
      >
        <List.Item.Meta
          style={{
            width: "55%",
          }}
          avatar={<Avatar src={item?.training?.imageUrl} />}
          title={
            <Space>
              {item?.training?.title}
              <TagFactory status={item?.status}>{item?.status?.toSentenceCase()}</TagFactory>
            </Space>
          }
          description={
            <Space direction="vertical">
              <Typography.Paragraph
                ellipsis={{
                  rows: 2,
                  expandable: true,
                  symbol: "more",
                }}
              >
                {stripHtml(item?.training?.descriptionAsHTML)}
              </Typography.Paragraph>
              {item?.status === "pending" && isAdmin && (
                <Space>
                  <Button
                    onClick={() => handleBooking("declined")}
                    type="danger"
                    size="small"
                    disabled={acceptLoading}
                    loading={rejectLoading}
                  >
                    Reject
                  </Button>
                  <Button
                    loading={acceptLoading}
                    disabled={rejectLoading}
                    onClick={() => handleBooking("requested")}
                    type="primary"
                    size="small"
                  >
                    Approve
                  </Button>
                </Space>
              )}
              <Badge
                color="purple"
                text={
                  <span className="badge--meta">
                    Date Range: {dayjs(item?.date[0]).format("DD/MM/YYYY")} -{" "}
                    {dayjs(item?.date[1]).format("DD/MM/YYYY")}
                  </span>
                }
              />
            </Space>
          }
        />
      </List.Item>
    </>
  )
}
